import { acts } from "../constants/acts.ts";
import {
  completeStep,
  finalizeEpisode,
  getCourseCompleted,
  getRawPoints,
} from "../store/globalStore.ts";

type ContextType = {
  navigate: (path: string) => void;
};

/* Validación de cada fase */
const setResult_1 = (value: number) => completeStep(acts.act1, value);

const setResult_2 = (value: number) => completeStep(acts.act2, value);

const setResult_3 = (value: number) => completeStep(acts.act3, value);

const openURL = (value: string) => window.open(value, "_blank");

export type ActionCallsType = {
  validate: () => void;
  setResult_1: (value: number) => void;
  setResult_2: (value: number) => void;
  setResult_3: (value: number) => void;
  openURL: (value: string) => void;
  finalizeEpisode: () => void;
};

export default function actionCalls({ navigate }: ContextType) {
  return {
    validate: () => {
      if (!getCourseCompleted()) {
        console.log(
          "[actionCalls] validate - curso no completado, rawPoints:",
          getRawPoints(),
        );
        return;
      }
      console.log(
        "[actionCalls] validate - curso completado, navegando con:",
        navigate,
      );
    },
    setResult_1,
    setResult_2,
    setResult_3,
    openURL,
    finalizeEpisode,
  };
}
